import {GetterTree} from 'vuex'
import DataVariableGroup from '../ts/DataVariableGroupInterface';
import compareDates from "../../../components/helpers/CompareDates";
import moment = require("moment");
import DataVariable from "../ts/DataVariableInterface";

export const getters: GetterTree<any, any> = {

    getFilteredDataVariables: (state, getters, rootState, rootGetters) => (filter: string) => {

        let variables = rootState.dataVariables;

        if (filter) {

            if (filter === 'NO GROUP') {
                variables = variables.filter((variable: DataVariable) => !variable.group);
            } else {
                variables = variables.filter((variable: DataVariable) => {
                    if (!variable.group) return false;
                    return variable.group.name === filter
                });
            }
        }

        if (state.typeFilterModel) {
            variables = variables.filter((variable: DataVariable) => variable[state.typeFilterModel] === true);
        }

        return variables;
    },

    recentGroups(state, getters, rootState, rootGetters) {

        let groups = [...state.groups];

        groups.sort((a: DataVariableGroup, b: DataVariableGroup) => {
            return compareDates(b.updated_at, a.updated_at);
        });

        let mostRecent = groups.slice(0, 3);
        let recent: Array<DataVariableGroup> = [];

        mostRecent.forEach((group) => {
            if (moment(group.updated_at) > moment().subtract(24, 'hours')) {
                recent.push(group);
            }
        });

        return recent;
    },

    alphaSortedGroups(state, getters, rootState, rootGetters) {

        let alphaSortedGroups = [...state.groups];

        alphaSortedGroups.sort((a: DataVariableGroup, b: DataVariableGroup) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });

        return alphaSortedGroups;
    }
}

